import axiosInstance from './axiosConfig';

export const createGroupApi = (payload) => axiosInstance.post('/groups', payload);

export const updateGroupApi = (id, payload) => axiosInstance.put(`/groups/${id}`, payload);

export const deleteGroupApi = (id) => axiosInstance.delete(`/groups/${id}`);

export const getGroupStandingsApi = (id) => axiosInstance.get(`/groups/${id}/standings`);

export const assignRegistrationToGroupApi = (groupId, registrationId) =>
  axiosInstance.post(`/groups/${groupId}/registrations`, { registrationId });

export const removeRegistrationFromGroupApi = (groupId, registrationId) =>
  axiosInstance.delete(`/groups/${groupId}/registrations/${registrationId}`);